export const DEPLOYMENT_FIELDS = {
  MIN_REPLICAS: {
    id: "minReplicas",
    label: "Min Replicas",
    min: 2,
    max: 30
  },
  CPU: {
    id: "cpu",
    label: "CPU"
  },
  MEMORY: {
    id: "memory",
    label: "Memory (Gi)",
    min: 2,
    max: 10
  },
  DEDICATED: {
    id: "dedicated",
    label: "Dedicated"
  },
  FORCE_MIN_REPLICAS: {
    id: "forceMinReplicas",
    label: "Force Min Replicas"
  }
};

export const SUCCESS_MESSAGE = "Your deployment changes have been submitted";
export const ERROR_MESSAGE = "An error occurred while submitting deployment changes. Please try again later";
export const DRAFT_EXISTS_MESSAGE = "A draft exists for this agent. Your changes will be saved to the draft version.";
export const DRAFT_NOT_EXISTS_MESSAGE = "Your changes will be applied directly to the live agent and trigger a redeployment.";

export const MIN_REPLICAS_TOOLTIP = "Minimum number of pods for this agent";
export const MEMORY_TOOLTIP = "Memory allocated per pod";

export const ERROR_TEXTS = {
  MIN_REPLICAS_REQUIRED: "Min replicas is required",
  MIN_REPLICAS_MIN: `Minimum replicas must be at least ${DEPLOYMENT_FIELDS.MIN_REPLICAS.min}`,
  MIN_REPLICAS_MAX: `Maximum replicas cannot exceed ${DEPLOYMENT_FIELDS.MIN_REPLICAS.max}`,
  MEMORY_REQUIRED: "Memory is required",
  MEMORY_MIN: `Memory must be at least ${DEPLOYMENT_FIELDS.MEMORY.min} Gi`,
  MEMORY_MAX: `Memory cannot exceed ${DEPLOYMENT_FIELDS.MEMORY.max} Gi`
};
